import genActTypes from "../core/types";

const types = genActTypes("tags");

export default types;
